<template lang="pug">
div
  section.full__video
    .intro__content.intro__content--mobile.intro__content--studio
      .studioLogo
        img(srcset='https://cdn.flixel.com/static/static-web/studios/flixelStudiosWhite2x.png 2x, https://cdn.flixel.com/static/static-web/studios/flixelStudiosWhite1x.png 1x')
    .fluid__video
      .intro__content.intro__content--desktop.intro__content--studio
        .studioLogo
          img(srcset='https://cdn.flixel.com/static/static-web/studios/flixelStudios2X.png 2x, https://cdn.flixel.com/static/static-web/studios/flixelStudios1x.png 1x')
      iframe(src='https://media.flixel.com/cinemagraph/by005206u1ucmntzr22b?hd=true' allow='autoplay')

  brands

  section.studio__section#intro
    .studio__content
      h1.studio__content--title Short Stories Move
      .studio__content--text
        p Need help with a cinemagraph campaign? Looking for inspiration on how to use micro-video content? Our award-winning Flixel Studios team can do it all. From strategy and concepts, to capture and post ― we work with many of the world's top brands, agencies and photographers.

        p We’ll energize your brand through visual storytelling. Done well, the magic of cinemagraphs and micro-videos deliver real engagement and business results.

      button.btn.btn--purpleLight(@click='goToForm') Work with us

  section.studio__section
    .studio__section--container
      .studio__section--content
        .studioItem__title
          h2 Cinemagraph activations

        .studioItem__desc
          p Cinemagraphs make for magical and fun brand activations. We create beautiful cinemagraph experiences that delight your guests and encourage social sharing. 

          p Flixel Studios has developed and executed both simple and elaborate cinemagraph photo booth experiences for leading brands like A&E, Disney, The Emmys, Facebook, HBO, Instagram, Lincoln, Marriott, Mashable, Panasonic, PepsiCo, and TED.

      .studio__section--image
        .fluid__video.studio__cinemagraph
          iframe(src='https://media.flixel.com/cinemagraph/q8ezg6dmxelur92bg7wt?hd=true' allow='autoplay')

  section.studio__section
    .studio__section--container.studio__section--reverse
      .studio__section--content
        .studioItem__title
          h2 Stills to Motion
        .studioItem__desc
          p We transform still photos and video into thumb-stopping cinemagraphs. Flixel Studios can review your company assets, stock library or video footage, and reimagine it as dynamic motion content ― with or without sound.

      .studio__section--image.image--reverse
        .fluid__video.studio__cinemagraph.studio__cinemagraph--marilyn
          iframe(src='https://media.flixel.com/cinemagraph/6zgfe6ow6pm2dr8o1sle?hd=true' allow='autoplay')

  section.studio__section
    .studio__section--container
      .studio__section--content
        .studioItem__title
          h2 Custom Digital Campaigns

        .studioItem__desc
          p We help your brand become better storytellers by creating new ways to reach and engage with your target markets. Flixel Studios can create custom digital campaigns and content for TV, digital signage, the web, social media ads and more.

      .studio__section--image
        .fluid__video.studio__cinemagraph
          iframe(src='https://media.flixel.com/cinemagraph/abog3firhfqn7imfm140/' allow='autoplay')

  section.studio__section#contactSection
    .studio__contactform
      .contactform
        h1 Contact Flixel Studios
        a(href='mailto:mark@flixel.com?subject=Work with Flixel Studios')
          button.btn.btn--purpleLight Contact Us
</template>

<script>
import Brands from 'components/Brands.vue';

export default {
  name: 'Studios',
  methods: {
    goToForm() {
      document.getElementById('contactSection').scrollIntoView();
    },
  },
  metaInfo: {
    title: 'Custom Cinemagraph Campaigns for Top Brands | Flixel',
    meta: [
      {
        'property': 'image',
        'content': 'https://cdn.flixel.com/static/static-web/FlixelStudios.png',
      },
      {
        'property': 'description',
        'content': 'Flixel Studios creates custom cinemagraph campaigns, stills-to-motion creatives, and live cinemagraph activations for top brands and marketers.',
      },
    ],
  },
  components: {
    'Brands': Brands,
  },
};
</script>




// WEBPACK FOOTER //
// src/views/Studios.vue